import { useEffect, useState, type CSSProperties } from "react";
import { MarkMotif } from "@mineoptics/brand/logo";
import { INTRO_SECONDS, shouldPlayIntro } from "@/lib/intro";

type Phase = "draw" | "lift" | "done";

/**
 * First visit of a browser session: the mark draws itself on a dark sheet,
 * then the sheet lifts off the page. About a second, never with reduced motion.
 */
export function Intro() {
  const [phase, setPhase] = useState<Phase>(() => (shouldPlayIntro() ? "draw" : "done"));

  useEffect(() => {
    if (!shouldPlayIntro()) return;
    const lift = window.setTimeout(() => setPhase("lift"), (INTRO_SECONDS - 0.5) * 1000);
    const done = window.setTimeout(() => setPhase("done"), INTRO_SECONDS * 1000 + 200);
    return () => {
      window.clearTimeout(lift);
      window.clearTimeout(done);
    };
  }, []);

  if (phase === "done") return null;

  return (
    <div
      aria-hidden="true"
      data-theme="dark"
      className={`pointer-events-none fixed inset-0 z-[80] flex items-center justify-center bg-bg transition-transform duration-700 ease-in-out-quart ${
        phase === "lift" ? "-translate-y-full" : "translate-y-0"
      }`}
    >
      <MarkMotif
        rings={1}
        strokeWidth={5}
        className="h-20 w-20 text-fg"
        style={{ "--mo-draw": "0.6s", "--mo-dot-delay": "0.25s" } as CSSProperties}
      />
    </div>
  );
}
